module.exports = __webpack_public_path__ + "/images/logo-ico-bg-badge.05b8a49.svg";